import { DOCUMENT } from "@angular/common";
import { Inject, Injectable, Renderer2, RendererFactory2 } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class GooglemapService {
  private renderer: Renderer2;
  constructor(
    public rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadScript(Google_API_Key) {
    if (Google_API_Key != '') {
      return new Promise<any>((resolve, reject) => {
        const script = this.renderer.createElement("script");
        script.type = "text/javascript";
        script.src = "https://maps.googleapis.com/maps/api/js?v=3&key=" + Google_API_Key + "&sensor=false&&libraries=places&callback=initMap";
        script.async = true;
        script.defer = true;
        this.renderer.appendChild(this.document.body, script);
        script.onload = resolve;
        script.onerror = reject;
      });

    }
  }
}
